var t = "_content_1syk0_1",
    o = "_buttonsRow_1syk0_7",
    n = {
  content: t,
  buttonsRow: o
};
export { o as buttonsRow, t as content, n as default };